/**
 * Company dashboard — GET /control/dashboard[/chart], tenant-scoped by X-Company-Id.
 * Both are read-only today's-state calls; the chart's `days` window defaults to 7 on
 * the server.
 */
import {requestControl} from '@/shared/api';
import type {DailyPassStat, DashboardSummary} from './types';

export function fetchDashboard(companyId: string): Promise<DashboardSummary> {
  return requestControl<DashboardSummary>('/control/dashboard', companyId);
}

/** The server wraps the series in {stats}; callers only want the array. */
export async function fetchDashboardChart(
  companyId: string,
  days = 7,
): Promise<DailyPassStat[]> {
  const res = await requestControl<{stats: DailyPassStat[]}>(
    `/control/dashboard/chart?days=${days}`,
    companyId,
  );
  return res.stats ?? [];
}
